import { render, staticRenderFns } from "./ListaTimesDetails.vue?vue&type=template&id=45e741ff&scoped=true&"
import script from "./ListaTimesDetails.vue?vue&type=script&lang=js&"
export * from "./ListaTimesDetails.vue?vue&type=script&lang=js&"
import style0 from "./ListaTimesDetails.vue?vue&type=style&index=0&id=45e741ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e741ff",
  null
  
)

export default component.exports